import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import {
  getPaymentOperations,
  getPaymentOperationsStats,
  getPaymentHistory,
  chargeStudentPayment,
  rejectStudent,
  sendFailedCourseReminder,
} from "../../../../api/payment";
import { getArchivosByUsuario, downloadArchivo } from "../../../../api/archivo";
import { getCursoById } from "../../../../api/curso";
import {
  Button,
  TextField,
  Chip,
  Tooltip,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import {
  Cancel,
  Autorenew as FilterOffIcon,
  GetApp,
  Email as EmailIcon,
} from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History";
import PaymentIcon from "@material-ui/icons/Payment";
import InfoIcon from "@material-ui/icons/Info";
import { alertError, alertSuccess } from "../../../../utils/logger";
import Select from "react-select";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { shallowEqual, useSelector } from "react-redux";
import {
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";

const PAYMENT_STATUS_OPTIONS = [
  { value: "pendiente", label: "Pendiente" },
  { value: "completado", label: "Completado" },
  { value: "fallido", label: "Fallido" },
  { value: "validar_estudiante", label: "Validar Estudiante" },
];

const DEFAULT_SELECTED_STATUS_VALUES = PAYMENT_STATUS_OPTIONS.filter(
  (option) => option.value !== "fallido",
).map((option) => option.value);

const normalizeEstadoFilter = (estadoValue) => {
  if (Array.isArray(estadoValue)) {
    return estadoValue;
  }
  if (typeof estadoValue === "string" && estadoValue) {
    return [estadoValue];
  }
  return DEFAULT_SELECTED_STATUS_VALUES;
};

function getData(payments) {
  return payments.map((payment) => {
    // Obtener título del curso (puede venir como objeto multilingüe o string)
    let cursoTitulo = "N/A";
    if (payment.curso) {
      if (typeof payment.curso.titulo === "object") {
        cursoTitulo =
          payment.curso.titulo.es ||
          payment.curso.titulo.ca ||
          Object.values(payment.curso.titulo)[0] ||
          "N/A";
      } else if (typeof payment.curso.titulo === "string") {
        cursoTitulo = payment.curso.titulo;
      }
    }
    console.log("Payment:", payment);

    return {
      id: payment._id,
      userId: payment.user?._id || null,
      userName:
        (
          (payment.user?.fullName || "") +
          " " +
          (payment.user?.apellido1 || "") +
          " " +
          (payment.user?.apellido2 || "")
        ).trim() || "N/A",
      userEmail: payment.user?.email || "N/A",
      nAso: payment.user?.nAso || "N/A",
      tipo: payment.tipo,
      tipoCuota: payment.tipoCuota, // Tipo de cuota elegido por el usuario (anual/semestral)
      amount: payment.amount,
      metodoPago: payment.metodoPago,
      estado: payment.estado,
      fechaPago: payment.fechaPago,
      fechaVencimiento: payment.fechaVencimiento,
      createdAt: payment.createdAt,
      observaciones: payment.observaciones,
      tipoUsuario: payment.userType?.titulo || "N/A",
      cursoTitulo: cursoTitulo,
      cursoId: payment.curso?._id || null,
    };
  });
}

const initialFilters = {
  tipo: null,
  estado: DEFAULT_SELECTED_STATUS_VALUES,
  metodoPago: null,
  search: "",
  startDate: "",
  endDate: "",
};

export default function PaymentOperationsPage() {
  const authUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual,
  );
  const readOnlyOps = isReadOnlyConsultor(authUser?.role);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterOptions, setFilterOptions] = useState(() => {
    const saved = localStorage.getItem("paymentOperationsPageFilters");
    if (!saved) return initialFilters;
    const parsed = JSON.parse(saved);
    return {
      ...initialFilters,
      ...parsed,
      estado: normalizeEstadoFilter(parsed.estado),
    };
  });
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem("paymentOperationsPage_searchText");
    return saved || "";
  });
  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [openChargeDialog, setOpenChargeDialog] = useState(false);
  const [selectedPaymentForCharge, setSelectedPaymentForCharge] = useState(
    null,
  );
  const [charging, setCharging] = useState(false);
  const [chargeRequestLoading, setChargeRequestLoading] = useState(false);
  const [chargeRequestLoadingText, setChargeRequestLoadingText] = useState(
    "Procesando...",
  );
  const [openCoursePaymentDialog, setOpenCoursePaymentDialog] = useState(false);
  const [selectedCoursePayment, setSelectedCoursePayment] = useState(null);
  const [courseDetails, setCourseDetails] = useState(null);
  const [loadingCourseDetails, setLoadingCourseDetails] = useState(false);
  const [userArchivos, setUserArchivos] = useState([]);
  const [loadingArchivos, setLoadingArchivos] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [openReminderDialog, setOpenReminderDialog] = useState(false);
  const [paymentForReminder, setPaymentForReminder] = useState(null);
  const [sendingReminder, setSendingReminder] = useState(false);

  useEffect(() => {
    fetchData();
    fetchStats();
  }, []);

  useEffect(() => {
    if (data.length) {
      handleSearch();
    }
  }, [filterOptions]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterOptions.tipo) params.tipo = filterOptions.tipo;
      if (filterOptions.estado?.length) params.estado = filterOptions.estado;
      if (filterOptions.metodoPago)
        params.metodoPago = filterOptions.metodoPago;
      if (filterOptions.startDate) params.startDate = filterOptions.startDate;
      if (filterOptions.endDate) params.endDate = filterOptions.endDate;

      const response = await getPaymentOperations(params);
      const formattedData = getData(response.data);
      setData(formattedData);
      setFilteredData(formattedData);
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al obtener pagos.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const params = {};
      if (filterOptions.startDate) params.startDate = filterOptions.startDate;
      if (filterOptions.endDate) params.endDate = filterOptions.endDate;

      const response = await getPaymentOperationsStats(params);
      setStats(response.data);
    } catch (error) {
      console.error("Error al obtener estadísticas:", error);
    }
  };

  const handleTableSearchChange = React.useCallback((value) => {
    const trimmedValue = value ? value : "";
    setSearchText(trimmedValue);
    if (trimmedValue) {
      localStorage.setItem("paymentOperationsPage_searchText", trimmedValue);
    } else {
      localStorage.removeItem("paymentOperationsPage_searchText");
    }
  }, []);

  const handleSearch = () => {
    localStorage.setItem(
      "paymentOperationsPageFilters",
      JSON.stringify(filterOptions),
    );
    fetchData();
    fetchStats();
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText("");
    localStorage.removeItem("paymentOperationsPageFilters");
    localStorage.removeItem("paymentOperationsPage_searchText");
    localStorage.removeItem("paymentOperationsPage_currentPage");
    fetchData();
    fetchStats();
  };

  const handleViewHistory = async (userId) => {
    if (!userId) return;
    setSelectedUserId(userId);
    setOpenHistoryDialog(true);
    setLoadingHistory(true);
    try {
      const response = await getPaymentHistory(userId);
      setPaymentHistory(response.data || []);
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al obtener el historial.",
      });
    } finally {
      setLoadingHistory(false);
    }
  };

  const handleViewCoursePayment = async (payment) => {
    setSelectedCoursePayment(payment);
    setOpenCoursePaymentDialog(true);
    setLoadingCourseDetails(true);
    setCourseDetails(null);

    if (payment.cursoId) {
      try {
        const response = await getCursoById(payment.cursoId);
        if (response.status === 200) {
          setCourseDetails(response.data);
        }
      } catch (error) {
        console.error("Error al obtener detalles del curso:", error);
        alertError({
          error,
          customMessage: "Error al obtener información del curso.",
        });
      } finally {
        setLoadingCourseDetails(false);
      }
    } else {
      setLoadingCourseDetails(false);
    }
  };

  const handleOpenChargeDialog = async (payment) => {
    setSelectedPaymentForCharge(payment);
    setOpenChargeDialog(true);

    // Cargar archivos del usuario si tiene userId
    if (payment.userId) {
      setLoadingArchivos(true);
      setUserArchivos([]);
      try {
        const response = await getArchivosByUsuario(payment.userId);
        setUserArchivos(response.data || []);
      } catch (error) {
        console.error("Error cargando archivos del usuario:", error);
        setUserArchivos([]);
      } finally {
        setLoadingArchivos(false);
      }
    }
  };

  const handleChargeStudent = async () => {
    if (!selectedPaymentForCharge) return;

    const paymentId = selectedPaymentForCharge.id;
    const tipoCuota = selectedPaymentForCharge.tipoCuota || "cuota";

    // Cerrar el modal y mostrar loader hasta respuesta del backend
    setOpenChargeDialog(false);
    setCharging(true);
    setChargeRequestLoadingText("Procesando cobro...");
    setChargeRequestLoading(true);
    try {
      const response = await chargeStudentPayment(paymentId);

      if (response.status === 200) {
        alertSuccess({
          customMessage: `Cuota ${tipoCuota} cobrada exitosamente.`,
        });
        fetchData();
        fetchStats();
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al cobrar la cuota de estudiante.",
      });
    } finally {
      setCharging(false);
      setChargeRequestLoading(false);
      setSelectedPaymentForCharge(null);
      setUserArchivos([]);
    }
  };

  const handleRejectStudent = async () => {
    if (!selectedPaymentForCharge) return;

    const paymentId = selectedPaymentForCharge.id;

    if (
      !window.confirm(
        "¿Estás seguro de que deseas rechazar a este estudiante? Se enviará un correo al usuario informándole del rechazo.",
      )
    ) {
      return;
    }

    setRejecting(true);
    // Cerrar el modal y mostrar loader hasta respuesta del backend
    setOpenChargeDialog(false);
    setChargeRequestLoadingText("Procesando rechazo...");
    setChargeRequestLoading(true);
    try {
      const response = await rejectStudent(paymentId);

      if (response.status === 200) {
        alertSuccess({
          customMessage:
            "Estudiante rechazado exitosamente. Se ha enviado un correo al usuario.",
        });
        fetchData();
        fetchStats();
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al rechazar el estudiante.",
      });
    } finally {
      setRejecting(false);
      setChargeRequestLoading(false);
      setSelectedPaymentForCharge(null);
      setUserArchivos([]);
    }
  };

  const handleDownloadArchivo = async (archivo) => {
    try {
      const response = await downloadArchivo(archivo._id);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = archivo.nombreOriginal;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alertError({
        error,
        customMessage: "Error al descargar el archivo.",
      });
    }
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "5px 0 0 0" }}>
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Nombre, email, número de socio..."
              value={searchText}
              onChange={(e) => handleTableSearchChange(e.target.value)}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <Select
              placeholder="Tipo"
              value={
                filterOptions.tipo
                  ? { value: filterOptions.tipo, label: filterOptions.tipo }
                  : null
              }
              onChange={(option) =>
                setFilterOptions({
                  ...filterOptions,
                  tipo: option ? option.value : null,
                })
              }
              options={[
                { value: "renovacion", label: "Renovación" },
                { value: "manual", label: "Manual" },
                { value: "alta_socio", label: "Alta Socio" },
                {
                  value: "actualizar_usuario",
                  label: "Actualizar Usuario",
                },
                { value: "inscripcion_curso", label: "Inscripción Curso" },
              ]}
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
                }),
              }}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <Select
              placeholder="Estado"
              value={PAYMENT_STATUS_OPTIONS.filter((option) =>
                (filterOptions.estado || []).includes(option.value),
              )}
              onChange={(options) =>
                setFilterOptions({
                  ...filterOptions,
                  estado: options ? options.map((option) => option.value) : [],
                })
              }
              options={PAYMENT_STATUS_OPTIONS}
              isMulti
              closeMenuOnSelect={false}
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
                }),
              }}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <Select
              placeholder="Método"
              value={
                filterOptions.metodoPago
                  ? {
                      value: filterOptions.metodoPago,
                      label:
                        filterOptions.metodoPago === "iban"
                          ? "IBAN"
                          : filterOptions.metodoPago === "paypal"
                          ? "PayPal"
                          : "Tarjeta",
                    }
                  : null
              }
              onChange={(option) =>
                setFilterOptions({
                  ...filterOptions,
                  metodoPago: option ? option.value : null,
                })
              }
              options={[
                { value: "iban", label: "IBAN" },
                { value: "tarjeta", label: "Tarjeta" },
                { value: "paypal", label: "PayPal" },
              ]}
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
                }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="startDate"
              label="Fecha inicio"
              type="date"
              value={filterOptions.startDate}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  startDate: e.target.value,
                })
              }
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="endDate"
              label="Fecha fin"
              type="date"
              value={filterOptions.endDate}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  endDate: e.target.value,
                })
              }
              margin="dense"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        <div className="row align-items-center mt-3">
          <div className="col-md-6"></div>
          <div
            className="col-md-6 d-flex justify-content-end"
            style={{ gap: "10px" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              startIcon={<SearchIcon />}
              style={{ backgroundColor: "#f3691a", color: "white" }}
            >
              Buscar
            </Button>
            <Button
              variant="outlined"
              onClick={handleClearFilters}
              startIcon={<FilterOffIcon />}
              style={{ borderColor: "#f3691a", color: "#f3691a" }}
            >
              Limpiar
            </Button>
          </div>
        </div>
      </div>
    );
  };

  // Estilo compacto en columna (varias líneas) para no solapar con columnas adyacentes
  const cellBadgeStyle = {
    maxWidth: "78px",
    fontSize: "0.75rem",
    lineHeight: 1.25,
    wordBreak: "break-word",
    padding: "4px 6px",
    borderRadius: "4px",
    display: "inline-block",
  };

  const estadoFormatter = (cell, row) => {
    const colors = {
      pendiente: "#9e9e9e",
      completado: "#1976d2",
      fallido: "#d32f2f",
      validar_estudiante: "#ed6c02",
      rechazo_estudiante: "#9e9e9e",
    };
    const labels = {
      validar_estudiante: "Validar Estudiante",
      rechazo_estudiante: "Rechazo Est.",
    };
    const label = labels[cell] || cell;
    return (
      <div
        style={{
          ...cellBadgeStyle,
          backgroundColor: colors[cell] || "#e0e0e0",
          color: "#fff",
        }}
      >
        {label}
      </div>
    );
  };

  const tipoFormatter = (cell) => {
    const labels = {
      renovacion: "Renovación",
      manual: "Manual",
      alta_socio: "Alta Socio",
      actualizar_usuario: "Actualizar Usuario",
      inscripcion_curso: "Inscripción Curso",
    };
    const label = labels[cell] || cell;
    return (
      <div
        style={{
          ...cellBadgeStyle,
          backgroundColor: "#e0e0e0",
          color: "rgba(0,0,0,0.87)",
        }}
      >
        {label}
      </div>
    );
  };

  const metodoPagoFormatter = (cell) => {
    if (cell === "tarjeta") {
      return <Chip label="Tarjeta" color="primary" size="small" />;
    }
    if (cell === "paypal") {
      return (
        <Chip
          label="PayPal"
          color="secondary"
          size="small"
          style={{ backgroundColor: "#003087", color: "#fff" }}
        />
      );
    }
    return <Chip label="IBAN" color="default" size="small" />;
  };

  const amountFormatter = (cell) => {
    return `${cell}€`;
  };

  const buttonFormatter = (cell, row) => {
    return (
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {row.estado === "validar_estudiante" && !readOnlyOps && (
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => handleOpenChargeDialog(row)}
            style={{
              minWidth: "auto",
              padding: "8px",
              backgroundColor: "#f3691a",
              color: "white",
            }}
            title="Cobrar cuota estudiante"
          >
            <PaymentIcon />
          </Button>
        )}
        {!readOnlyOps &&
          (row.estado === "fallido" || row.estado === "pendiente") &&
          row.tipo === "inscripcion_curso" &&
          row.userId && (
            <Tooltip title="Enviar correo recordatorio para inscribirse">
              <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={() => {
                  setPaymentForReminder(row);
                  setOpenReminderDialog(true);
                }}
                style={{ minWidth: "auto", padding: "8px" }}
              >
                <EmailIcon />
              </Button>
            </Tooltip>
          )}
        {row.tipo === "inscripcion_curso" ? (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleViewCoursePayment(row)}
            style={{ minWidth: "auto", padding: "8px" }}
            title="Ver detalles del curso"
          >
            <InfoIcon />
          </Button>
        ) : (
          row.userId && (
            <Button
              size="small"
              variant="outlined"
              color="default"
              onClick={() => handleViewHistory(row.userId)}
              style={{ minWidth: "auto", padding: "8px" }}
              title="Ver historial"
            >
              <HistoryIcon />
            </Button>
          )
        )}
      </div>
    );
  };

  const columns = [
    {
      dataField: "userName",
      text: "Nombre y Apellido",
      sort: true,
    },
    {
      dataField: "userEmail",
      text: "Email",
      sort: true,
    },
    {
      dataField: "nAso",
      text: "Nº Socio",
      sort: true,
    },
    {
      dataField: "tipo",
      text: "Tipo",
      formatter: tipoFormatter,
      sort: true,
      headerStyle: { width: "90px", minWidth: "90px" },
      style: { width: "90px", minWidth: "90px", verticalAlign: "middle" },
    },
    {
      dataField: "tipoCuota",
      text: "Cuota",
      formatter: (cell) => {
        if (!cell) return "-";
        return cell === "anual" ? "Anual" : "Semestral";
      },
      sort: true,
      headerStyle: { width: "80px", minWidth: "80px" },
      style: { width: "80px", minWidth: "80px" },
    },
    {
      dataField: "amount",
      text: "Importe",
      formatter: amountFormatter,
      sort: true,
    },
    {
      dataField: "metodoPago",
      text: "Método",
      formatter: metodoPagoFormatter,
      sort: true,
    },
    {
      dataField: "estado",
      text: "Estado",
      formatter: estadoFormatter,
      sort: true,
      headerStyle: { width: "90px", minWidth: "90px" },
      style: { width: "90px", minWidth: "90px", verticalAlign: "middle" },
    },
    {
      dataField: "fechaPago",
      text: "Fecha Pago",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Fecha Creación",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "actions",
      text: "Acciones",
      formatter: buttonFormatter,
      sort: false,
      headerStyle: { width: "10%" },
    },
  ];

  return (
    <>
      <Card>
        <CardHeader title="Gestión de Pagos Operativos">
          {stats && (
            <div
              className="d-flex mt-3"
              style={{ gap: "20px", flexWrap: "wrap", alignItems: "center" }}
            >
              <div>
                <strong>Total Renovaciones:</strong> {stats.totalRenovaciones}
              </div>
              <div>
                <strong>Total Manuales:</strong> {stats.totalManuales}
              </div>
              <div>
                <strong>Total Altas:</strong> {stats.totalAltas}
              </div>
              <div>
                <strong>Total Actualizar Usuario:</strong>{" "}
                {stats.totalActualizarUsuario || 0}
              </div>
              <div>
                <strong>Total Cursos:</strong> {stats.totalCursos || 0}
              </div>
              <div>
                <strong>Completados:</strong>{" "}
                <Chip label={stats.completados} color="primary" size="small" />
              </div>
              <div>
                <strong>Pendientes:</strong>{" "}
                <Chip label={stats.pendientes} color="default" size="small" />
              </div>
              <div>
                <strong>Fallidos:</strong>{" "}
                <Chip label={stats.fallidos} color="secondary" size="small" />
              </div>
              {stats.validarEstudiante !== undefined && (
                <div>
                  <strong>Validar Estudiante:</strong>{" "}
                  <Chip
                    label={stats.validarEstudiante}
                    color="secondary"
                    size="small"
                  />
                </div>
              )}
              <div>
                <strong>Recaudación Total:</strong>{" "}
                {stats.recaudacionTotal.toFixed(2)}€
              </div>
            </div>
          )}
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>
          <Table
            columns={columns}
            data={filteredData}
            pageKey="paymentOperationsPage"
            searchText={searchText}
            onSearchChange={handleTableSearchChange}
            loading={loading}
          />
        </CardBody>
      </Card>

      {/* Dialog de Historial */}
      <Dialog
        open={openHistoryDialog}
        onClose={() => setOpenHistoryDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Historial de Pagos</DialogTitle>
        <DialogContent>
          {loadingHistory ? (
            <Typography>Cargando...</Typography>
          ) : paymentHistory.length === 0 ? (
            <Typography>No hay pagos registrados.</Typography>
          ) : (
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Importe</TableCell>
                  <TableCell>Método</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell>Tipo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentHistory.map((payment) => (
                  <TableRow key={payment._id}>
                    <TableCell>
                      {payment.fechaPago
                        ? new Date(payment.fechaPago).toLocaleDateString(
                            "es-ES",
                          )
                        : "-"}
                    </TableCell>
                    <TableCell>{payment.amount}€</TableCell>
                    <TableCell>
                      {payment.metodoPago === "tarjeta"
                        ? "Tarjeta"
                        : payment.metodoPago === "paypal"
                        ? "PayPal"
                        : payment.metodoPago === "gratis"
                        ? "Gratis"
                        : "IBAN"}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={payment.estado}
                        color={
                          payment.estado === "completado"
                            ? "primary"
                            : payment.estado === "fallido"
                            ? "secondary"
                            : "default"
                        }
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{payment.tipo}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </MuiTable>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenHistoryDialog(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Cobro de Cuota Estudiante */}
      <Dialog
        open={openChargeDialog}
        onClose={() => {
          if (!charging) {
            setOpenChargeDialog(false);
            setSelectedPaymentForCharge(null);
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Cobrar Cuota de Estudiante</DialogTitle>
        <DialogContent>
          {selectedPaymentForCharge && (
            <div>
              <Typography variant="body1" style={{ marginBottom: "16px" }}>
                <strong>Usuario:</strong> {selectedPaymentForCharge.userName}
              </Typography>
              <Typography variant="body1" style={{ marginBottom: "16px" }}>
                <strong>Email:</strong> {selectedPaymentForCharge.userEmail}
              </Typography>
              <Typography variant="body1" style={{ marginBottom: "16px" }}>
                <strong>Nº Socio:</strong> {selectedPaymentForCharge.nAso}
              </Typography>
              {selectedPaymentForCharge.tipoCuota && (
                <Typography variant="body1" style={{ marginBottom: "16px" }}>
                  <strong>Tipo de cuota elegida:</strong>{" "}
                  {selectedPaymentForCharge.tipoCuota === "anual"
                    ? "Anual"
                    : "Semestral"}
                </Typography>
              )}
              <Typography
                variant="body2"
                style={{ marginBottom: "24px", color: "#666" }}
              >
                Se cobrará la cuota{" "}
                {selectedPaymentForCharge.tipoCuota === "anual"
                  ? "anual"
                  : "semestral"}{" "}
                correspondiente a la tarjeta registrada durante la validación.
              </Typography>

              {/* Sección de archivos del usuario */}
              <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                <Typography
                  variant="subtitle1"
                  style={{ marginBottom: "12px", fontWeight: "bold" }}
                >
                  Documento subido:
                </Typography>
                {loadingArchivos ? (
                  <Typography variant="body2" style={{ color: "#666" }}>
                    Cargando archivos...
                  </Typography>
                ) : userArchivos.length > 0 ? (
                  <div>
                    {userArchivos.map((archivo) => (
                      <div
                        key={archivo._id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography variant="body2">
                          {archivo.nombreOriginal}
                        </Typography>
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          startIcon={<GetApp />}
                          onClick={() => handleDownloadArchivo(archivo)}
                          style={{ minWidth: "auto" }}
                        >
                          Descargar
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <Typography variant="body2" style={{ color: "#666" }}>
                    No se encontraron archivos para este usuario.
                  </Typography>
                )}
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenChargeDialog(false);
              setSelectedPaymentForCharge(null);
              setUserArchivos([]);
            }}
            disabled={charging || rejecting}
            color="default"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleRejectStudent}
            disabled={charging || rejecting || readOnlyOps}
            color="secondary"
            startIcon={<Cancel />}
            style={{ marginRight: "8px" }}
          >
            {rejecting ? "Rechazando..." : "Rechazar Estudiante"}
          </Button>
          <Button
            onClick={handleChargeStudent}
            disabled={charging || rejecting || readOnlyOps}
            color="primary"
            variant="contained"
            style={{ backgroundColor: "#f3691a", color: "white" }}
          >
            {charging ? "Cobrando..." : "Cobrar Cuota"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Detalles de Pago de Curso */}
      <Dialog
        open={openCoursePaymentDialog}
        onClose={() => {
          setOpenCoursePaymentDialog(false);
          setSelectedCoursePayment(null);
          setCourseDetails(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Detalles de Inscripción en Curso</DialogTitle>
        <DialogContent>
          {loadingCourseDetails ? (
            <Typography>Cargando información del curso...</Typography>
          ) : selectedCoursePayment ? (
            <div style={{ paddingTop: "16px" }}>
              {/* Información del Pago */}
              <Typography
                variant="h6"
                style={{ marginBottom: "16px", fontWeight: "bold" }}
              >
                Información del Pago
              </Typography>
              <MuiTable size="small">
                <TableBody>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold", width: "40%" }}>
                      Usuario:
                    </TableCell>
                    <TableCell>{selectedCoursePayment.userName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>Email:</TableCell>
                    <TableCell>{selectedCoursePayment.userEmail}</TableCell>
                  </TableRow>
                  {selectedCoursePayment.nAso !== "N/A" && (
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Nº Socio:
                      </TableCell>
                      <TableCell>{selectedCoursePayment.nAso}</TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Importe:
                    </TableCell>
                    <TableCell>{selectedCoursePayment.amount}€</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Método de Pago:
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          selectedCoursePayment.metodoPago === "tarjeta"
                            ? "Tarjeta"
                            : selectedCoursePayment.metodoPago === "paypal"
                            ? "PayPal"
                            : selectedCoursePayment.metodoPago === "gratis"
                            ? "Gratis"
                            : "IBAN"
                        }
                        color={
                          selectedCoursePayment.metodoPago === "tarjeta"
                            ? "primary"
                            : selectedCoursePayment.metodoPago === "paypal"
                            ? "secondary"
                            : "default"
                        }
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Estado:
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          selectedCoursePayment.estado === "completado"
                            ? "Completado"
                            : selectedCoursePayment.estado
                        }
                        color={
                          selectedCoursePayment.estado === "completado"
                            ? "primary"
                            : selectedCoursePayment.estado === "fallido"
                            ? "secondary"
                            : "default"
                        }
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Fecha de Pago:
                    </TableCell>
                    <TableCell>
                      {selectedCoursePayment.fechaPago
                        ? new Date(
                            selectedCoursePayment.fechaPago,
                          ).toLocaleDateString("es-ES")
                        : "-"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Fecha de Creación:
                    </TableCell>
                    <TableCell>
                      {selectedCoursePayment.createdAt
                        ? new Date(
                            selectedCoursePayment.createdAt,
                          ).toLocaleDateString("es-ES")
                        : "-"}
                    </TableCell>
                  </TableRow>
                  {selectedCoursePayment.observaciones && (
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Observaciones:
                      </TableCell>
                      <TableCell>
                        {selectedCoursePayment.observaciones}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </MuiTable>

              {/* Información del Curso */}
              {courseDetails && (
                <>
                  <Typography
                    variant="h6"
                    style={{
                      marginTop: "32px",
                      marginBottom: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Información del Curso
                  </Typography>
                  <MuiTable size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold", width: "40%" }}>
                          Título:
                        </TableCell>
                        <TableCell>
                          {(() => {
                            if (typeof courseDetails.titulo === "object") {
                              return (
                                courseDetails.titulo.es ||
                                courseDetails.titulo.ca ||
                                Object.values(courseDetails.titulo)[0] ||
                                ""
                              );
                            }
                            return courseDetails.titulo || "";
                          })()}
                        </TableCell>
                      </TableRow>
                      {courseDetails.code && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Código:
                          </TableCell>
                          <TableCell>{courseDetails.code}</TableCell>
                        </TableRow>
                      )}
                      {courseDetails.fechaIni && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Fecha Inicio:
                          </TableCell>
                          <TableCell>
                            {new Date(
                              courseDetails.fechaIni,
                            ).toLocaleDateString("es-ES")}
                          </TableCell>
                        </TableRow>
                      )}
                      {courseDetails.fechaFin && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Fecha Fin:
                          </TableCell>
                          <TableCell>
                            {new Date(
                              courseDetails.fechaFin,
                            ).toLocaleDateString("es-ES")}
                          </TableCell>
                        </TableRow>
                      )}
                      {courseDetails.modalidad && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Modalidad:
                          </TableCell>
                          <TableCell>{courseDetails.modalidad}</TableCell>
                        </TableRow>
                      )}
                      {courseDetails.creditos !== undefined && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Créditos CFC:
                          </TableCell>
                          <TableCell>{courseDetails.creditos}</TableCell>
                        </TableRow>
                      )}
                      {courseDetails.duracion && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Duración:
                          </TableCell>
                          <TableCell>{courseDetails.duracion}</TableCell>
                        </TableRow>
                      )}
                      {courseDetails.lugar && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Lugar:
                          </TableCell>
                          <TableCell>
                            {(() => {
                              if (typeof courseDetails.lugar === "object") {
                                // Si tiene nombre como objeto
                                if (courseDetails.lugar.nombre) {
                                  if (
                                    typeof courseDetails.lugar.nombre ===
                                    "object"
                                  ) {
                                    return (
                                      courseDetails.lugar.nombre.es ||
                                      courseDetails.lugar.nombre.ca ||
                                      Object.values(
                                        courseDetails.lugar.nombre,
                                      )[0] ||
                                      ""
                                    );
                                  }
                                  return courseDetails.lugar.nombre || "";
                                }
                                // Si el lugar mismo es un objeto con es/ca
                                if (
                                  courseDetails.lugar.es ||
                                  courseDetails.lugar.ca
                                ) {
                                  return (
                                    courseDetails.lugar.es ||
                                    courseDetails.lugar.ca ||
                                    ""
                                  );
                                }
                                // Intentar obtener cualquier valor string del objeto
                                const values = Object.values(
                                  courseDetails.lugar,
                                ).filter((v) => typeof v === "string");
                                return values[0] || "";
                              }
                              return courseDetails.lugar || "";
                            })()}
                          </TableCell>
                        </TableRow>
                      )}
                      {courseDetails.direccion && (
                        <TableRow>
                          <TableCell style={{ fontWeight: "bold" }}>
                            Dirección:
                          </TableCell>
                          <TableCell>{courseDetails.direccion}</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </MuiTable>
                </>
              )}
            </div>
          ) : (
            <Typography>No hay información disponible.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenCoursePaymentDialog(false);
              setSelectedCoursePayment(null);
              setCourseDetails(null);
            }}
            color="primary"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ConfirmDialog para enviar recordatorio de inscripción (pago fallido) */}
      <ConfirmDialog
        title="¿Enviar correo recordatorio?"
        open={openReminderDialog}
        setOpen={(value) => {
          setOpenReminderDialog(value);
          if (!value) {
            setPaymentForReminder(null);
          }
        }}
        onConfirm={() => {
          if (paymentForReminder?.id) {
            setSendingReminder(true);
            sendFailedCourseReminder(paymentForReminder.id)
              .then(() => {
                alertSuccess({
                  customMessage:
                    "Correo recordatorio enviado. Se ha enviado un email al usuario para animarle a inscribirse.",
                });
                setPaymentForReminder(null);
              })
              .catch((error) => {
                alertError({
                  error,
                  customMessage:
                    "No se ha podido enviar el correo recordatorio.",
                });
              })
              .finally(() => {
                setSendingReminder(false);
              });
          }
        }}
      >
        <Typography variant="body2" style={{ marginTop: "10px" }}>
          Se enviará un email de recordatorio al usuario (
          {paymentForReminder?.userEmail}) para animarle a completar la
          inscripción en el curso.
          <br />
          <br />
          ¿Deseas continuar?
        </Typography>
      </ConfirmDialog>
      {/* Backdrop/Spinner global para operaciones de cobro/rechazo */}
      <Backdrop
        open={chargeRequestLoading}
        style={{
          zIndex: 9999,
          color: "#fff",
          flexDirection: "column",
          gap: "16px",
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
      >
        <CircularProgress color="inherit" size={60} />
        <span style={{ fontSize: "1.1rem", fontWeight: 500 }}>
          {chargeRequestLoadingText}
        </span>
      </Backdrop>
    </>
  );
}
